import { memo } from "react";
import Dialog from "@mui/material/Dialog";
import "./CustomDialog.css";

const CustomDialog = ({ open, onClose, children, className = "" }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <div className={`modal-container ${className}`}>{children}</div>
    </Dialog>
  );
};

export default memo(CustomDialog);
